// All-blank TLE exponent fields represent zero. Validate any checksum first:
// normalization changes text without changing the original checksum digit.
export const normalizeTleExponents = (line1: string) => {
  const fields = [line1.slice(44, 52), line1.slice(53, 61)].map((field) =>
    field === "        " ? " 00000-0" : field,
  );
  return (
    line1.slice(0, 44) +
    fields[0] +
    line1.slice(52, 53) +
    fields[1] +
    line1.slice(61)
  );
};
